import { message } from 'antd';
import { useDispatch } from 'dva';
import { useState } from 'react';
import { isMobile } from '@/utils/validation';
import Loading from '@/components/Loading';
import AddMemberStyled from './AddMemberStyled';
// import { brandCodeMap } from '@/constants';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  InputLabel,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import ModalML from '@/components/ModalML';
import { useTheme } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import webStorage from '@/utils/storageManager';

const AddMember = (props) => {
  const theme = useTheme();
  const {
    control,
    errors,
    handleSubmit,
    // getValues,
    // register,
  } = useForm({});
  const genderList = [
    {
      name: '男',
      value: '1',
    },
    {
      name: '女',
      value: '2',
    },
    {
      name: '未知',
      value: '0',
    },
  ];

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  // 发起请求
  const handleSubmitSuccess = (values) => {
    console.log(values);
    setLoading(true);
    dispatch({
      type: 'memberManagement/addMember',
      payload: {
        values: {
          memberIdentityRequestList: [
            {
              identityName: values.name,
              identityType: 1,
              identityValue: values.mobile,
            },
          ],
          membershipRequest: {
            gender: values.gender,
            mobile: values.mobile,
            name: values.name,
            brandId: webStorage.get('BRAND_CODE'),
          },
        },
      },
      callback: (data) => {
        console.log('data', data);
        setLoading(false);
        if (data?.code === 0) {
          message.success('新增成功');
          props.handleOk(data);
        } else {
          message.error(data.message);
        }
      },
    });
  };
  // const handleSubmitFaild = (values) => {
  //   console.log('jjjj');
  // };
  const handleCancel = () => {
    props.handleCancel();
  };

  // //校验手机号
  // const validatorMobile = (rule, value, callback) => {
  //   const re = /^1(3|4|5|6|7|8|9)\d{9}$/;
  //   if (value || re.test(value)) {
  //     callback();
  //   } else {
  //     callback('手机号填写错误');
  //   }
  // };

  return (
    props.open && (
      <ModalML
        open={props.open}
        onCancel={handleCancel}
        title={'新增'}
        onConfirm={handleSubmitSuccess}
        onClose={props.onClose}
      >
        <AddMemberStyled theme={theme}>
          <form
            onSubmit={handleSubmit(
              () => {
                console.log('hihi');
              },
              (values) => {
                console.log('values', values);
              },
            )}
          >
            <Loading loading={loading}>
              <Box className="box">
                <Controller
                  as={TextField}
                  name="name"
                  control={control}
                  id="basic"
                  placeholder="请输入会员姓名"
                  className="input"
                  label="*会员姓名"
                  rules={{ required: true }}
                  error={Boolean(errors.name)}
                  helperText={Boolean(errors.name) && '请输入会员姓名'}
                  defaultValue=""
                />
              </Box>
              <Box mt={4} className="box">
                <Controller
                  as={TextField}
                  name="mobile"
                  control={control}
                  id="basic"
                  className="input"
                  label="*手机号码"
                  helperText={Boolean(errors.mobile) && '请输入会员手机号'}
                  rules={{
                    required: true,
                    validate: {
                      numRange: isMobile,
                    },
                  }}
                  error={Boolean(errors.mobile)}
                  placeholder="请输入手机号码"
                  defaultValue=""
                />
              </Box>
              <Box mt={4} className="box">
                <FormControl
                  variant="standard"
                  className="channel single-select"
                >
                  <InputLabel>*性别</InputLabel>
                  <Controller
                    as={
                      <Select className="select">
                        {genderList.map((item) => (
                          <MenuItem
                            key={item.value}
                            value={item.value}
                            name={item.value}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                    label="*性别"
                    placeholder="请选择性别"
                    name="gender"
                    rules={{ required: true }}
                    error={Boolean(errors.gender)}
                    control={control}
                    defaultValue=""
                  />
                  <FormHelperText error={Boolean(errors.gender)}>
                    {Boolean(errors.gender) && '请选择性别'}
                  </FormHelperText>
                </FormControl>
              </Box>
              <Box className="buttonWrap">
                <Button
                  onClick={props.onClose}
                  variant="contained"
                  color="secondary"
                >
                  {props.cancelText ? props.cancelText : '取 消'}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  className="btnSubmit button"
                >
                  {props.confirmText ? props.confirmText : '保 存'}
                </Button>
              </Box>
            </Loading>
          </form>
        </AddMemberStyled>
      </ModalML>
    )
  );
};

export default AddMember;
